import { render, staticRenderFns } from "./OurJourney.vue?vue&type=template&id=7b16d6c1&scoped=true&"
import script from "./OurJourney.vue?vue&type=script&lang=js&"
export * from "./OurJourney.vue?vue&type=script&lang=js&"
import style0 from "./OurJourney.vue?vue&type=style&index=0&id=7b16d6c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b16d6c1",
  null
  
)

export default component.exports